import * as navigator from "client_legacy/ndaw/navigator";
import * as path from "client_legacy/Documents/path";
import { WebDavServerModel } from "client/Api/Documents/WebDav/webDav";

interface WebDavFileSystemItemForLocalOpening {
	id: string;
	name: string;
}

function open(server: WebDavServerModel, item: WebDavFileSystemItemForLocalOpening) {
	const url = getLocalAppUrl(server, item);
	if (url) {
		navigator.navigateTo(url);
	} else {
		throw new Error("Unable to open item: `" + item.id + "`");
	}
}

function getLocalAppUrl(server: WebDavServerModel, item: WebDavFileSystemItemForLocalOpening) {
	const extension = path.getExtension(item.name);

	let appPrefix;

	switch (extension.toLowerCase()) {
		case ".doc":
		case ".docx":
		case ".dotx":
		case ".docm":
		case ".dotm":
			appPrefix = "ms-word:ofe|u|";
			break;
		case ".csv":
		case ".xls":
		case ".xlsb":
		case ".xlsm":
		case ".xlsx":
			appPrefix = "ms-excel:ofe|u|";
			break;
		case ".potx":
		case ".pptx":
		case ".ppt":
		case ".pptm":
			appPrefix = "ms-powerpoint:ofe|u|";
			break;
		case ".one":
			appPrefix = "onenote:";
			break;
		default:
			// Not supported
			break;
	}

	if (!appPrefix) {
		return null;
	}

	let serverUrl = server.url;
	if (serverUrl[serverUrl.length - 1] === "/") {
		// Remove the ending "/" if any
		serverUrl = serverUrl.substring(0, serverUrl.length - 1);
	}

	return encodePath(appPrefix + server.url + decodeURIComponent(item.id));
}

function encodePath(url: string) {
	return encodeURI(url).replace(/#/g, "%23");
}

export {
	open
};
